export const SEARCH_TEXT_CHANGE = "SEARCH_TEXT_CHANGE";